export const CANVAS_RETAIL_EUR_TO_SGD_MULTIPLIER = 1.86;

export const CANVAS_OWN_WALL_MOUNT_SKU = "OWN_WALL_MOUNT";
export const CANVAS_OWN_WALL_MOUNT_NAME = "I have my own mount";

const CANVAS_SWIVEL_STAND_BLACK_IMAGE =
  "/catalogue-configurator/canvas/accessories/swivel-stand-black.jpg";
const CANVAS_SWIVEL_STAND_SILVER_IMAGE =
  "/catalogue-configurator/canvas/accessories/swivel-stand-silver.jpg";

export function canvasRetailSgdFromEur(eur: number): number {
  return Math.round((eur * CANVAS_RETAIL_EUR_TO_SGD_MULTIPLIER) / 10) * 10;
}

export const CANVAS_EVENT_STANDS = [
  {
    sku: "SS54BL+SS-BBC",
    name: 'Canvas Swivel Stand 55–65" — Black',
    eur: 899,
    sgd: canvasRetailSgdFromEur(899),
    sizes: [55, 65],
    finish: "Black",
    imagePath: CANVAS_SWIVEL_STAND_BLACK_IMAGE,
  },
  {
    sku: "SS54SLV+SS-SBC",
    name: 'Canvas Swivel Stand 55–65" — Silver',
    eur: 899,
    sgd: canvasRetailSgdFromEur(899),
    sizes: [55, 65],
    finish: "Silver",
    imagePath: CANVAS_SWIVEL_STAND_SILVER_IMAGE,
  },
  {
    sku: "SS75BL+SS-BBC",
    name: 'Canvas Swivel Stand 75–85" — Black',
    eur: 1149,
    sgd: canvasRetailSgdFromEur(1149),
    sizes: [75, 77, 83, 85],
    finish: "Black",
    imagePath: CANVAS_SWIVEL_STAND_BLACK_IMAGE,
  },
  {
    sku: "SS75SLV+SS-SBC",
    name: 'Canvas Swivel Stand 75–85" — Silver',
    eur: 1149,
    sgd: canvasRetailSgdFromEur(1149),
    sizes: [75, 77, 83, 85],
    finish: "Silver",
    imagePath: CANVAS_SWIVEL_STAND_SILVER_IMAGE,
  },
] as const;

export const PS80_PUBLIC_DESCRIPTION =
  "Heavy-duty articulated wall mount for 80–110-inch televisions. Smooth one-handed movement makes it easy to pull the television forward for cable access and new connections. Rated for loads up to 120 kg and recommended with Canvas for televisions 83 inches and above.";
